export default "__VITE_ASSET__DaM7b_c___"